import { BillingManagement } from "@/components/BillingManagement";

export default function BillingPage() {
  return <BillingManagement />;
}


